export default "__VITE_ASSET__CVRPJ0pz__"